import React from 'react';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
// import mapPropsOnChange from 'recompose/mapPropsOnChange';
import { Motion } from 'react-motion';
import cx from 'classnames';

// components
import { clusterMarkerHOC } from './cluster-marker.js';
import simpleMarkerStyles from './cluster-map.module.scss';

export const simpleMarker = props => {
  const { styles, defaultMotionStyle, motionStyle, onClick, points } = props;

  return (
    <React.Fragment>
      <Motion defaultStyle={defaultMotionStyle} style={motionStyle}>
        {({ scale }) => (
          <div
            className={cx(styles.simpleMarker, {
              [styles.selected]: points[0].selected
            })}
            style={{
              transform: `translate3D(0,0,0) scale(${scale}, ${scale})`
            }}
            onClick={onClick}
          />
        )}
      </Motion>
      {/*<div className={styles.simpleMarkerPopup}>TEST</div>*/}
    </React.Fragment>
  );
};

export const simpleMarkerHOC = compose(
  defaultProps({
    styles: simpleMarkerStyles,
    initialScale: 0.3,
    defaultScale: 0.6,
    hoveredScale: 0.7
  }),
  // resuse HOC
  clusterMarkerHOC
);

export default simpleMarkerHOC(simpleMarker);



// WEBPACK FOOTER //
// ./src/components/cluster-map/markers/simple-marker.js